export default [
  { id: 1, title: "Restaurant", code: "RS" },
  { id: 2, title: "Grocer", code: "GR" },
  { id: 3, title: "Manufacturer", code: "MR" },
  { id: 4, title: "Slaughter House", code: "SH" },
  { id: 5, title: "Kitchen", code: "KT" },
  { id: 7, title: "Distributor", code: "DR" },
];
